/** @format */

import React from "react";
import AccountInfoPageView from "./AccountInfoPage.view";
import {
	useFetchAccount,
	useFetchAccountUsers,
} from "../../../apis/swr/fetchers";

interface IAccountInfoPageContainer {
	params: { id: string };
}

const AccountInfoPageContainer: React.FC<IAccountInfoPageContainer> = (
	props
) => {
	const {
		users,
		isLoading: isLoadingUsers,
		mutate,
	} = useFetchAccountUsers(props.params.id);
	const { account, isLoading: isLoadingAccount } = useFetchAccount(
		props.params.id
	);

	return (
		<div>
			<AccountInfoPageView
				users={users ? users : []}
				account={account}
				params={props.params}
				fetchAndSetUsers={mutate}
				isLoading={isLoadingUsers || isLoadingAccount}
			/>
		</div>
	);
};

export default AccountInfoPageContainer;
